module.exports = __webpack_public_path__ + "img/H-B-5-load-connect-shadow.19d301d0.png";